import { InjectionToken, Type } from '@angular/core';

export const PORTAL_SIDEBAR_COMPONENT = new InjectionToken<Type<unknown>>(
  'PortalSidebarComponent'
);
